import React from "react";

export function StockHistoryModal({ isOpen, onClose, historyData, loading, error, productName }) {
  if (!isOpen) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return isNaN(date.getTime())
      ? dateStr
      : date.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="relative w-full max-w-4xl max-h-[85vh] overflow-hidden rounded-xl bg-white p-6 shadow-2xl flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between border-b pb-4 mb-4">
          <div>
            <h2 className="text-base font-bold uppercase tracking-wide text-gray-900">
              Stock Transaction History
            </h2>
            {productName && (
              <p className="text-xs text-gray-500 font-medium mt-0.5">Product: {productName}</p>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-lg font-bold"
          >
            ✕
          </button>
        </div>

        {/* Content Body */}
        <div className="flex-1 overflow-y-auto space-y-4">
          {loading && (
            <div className="py-12 text-center text-xs text-gray-500">
              Loading stock transactions...
            </div>
          )}

          {error && (
            <div className="rounded-md bg-red-50 p-3 text-xs text-red-600">
              {error}
            </div>
          )}

          {!loading && !error && (
            <div className="overflow-x-auto rounded-lg border border-gray-200">
              <table className="w-full border-collapse text-left text-xs">
  <thead>
    <tr className="border-b border-gray-200 bg-gray-100 text-gray-700 font-semibold">
      <th className="py-2.5 px-3">Date & Time</th>
      <th className="py-2.5 px-3">Type</th>
      <th className="py-2.5 px-3 text-right">Quantity Change</th>
      <th className="py-2.5 px-3 text-right">Previous</th>
      <th className="py-2.5 px-3 text-right">New Balance</th>
      <th className="py-2.5 px-3">Customer Info</th>
      <th className="py-2.5 px-3">Location</th>
      <th className="py-2.5 px-3">Inquiry Reference</th>
      {/* <th className="py-2.5 px-3">Note</th> */}
    </tr>
  </thead>
  <tbody className="divide-y divide-gray-200">
    {historyData && historyData.length > 0 ? (
      historyData.map((item) => {
        const isDecrease = item.transaction_type === "decrease";
        
        // Format location string dynamically
        const location = [item.customer_city, item.customer_state, item.customer_country]
          .filter(Boolean)
          .join(", ");

        return (
          <tr key={item.id} className="hover:bg-gray-50/50">
            <td className="py-2.5 px-3 text-gray-600 font-medium whitespace-nowrap">
              {formatDate(item.created_at)}
            </td>
            <td className="py-2.5 px-3">
              <span
                className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase ${
                  isDecrease
                    ? "bg-red-50 text-red-700 border border-red-200"
                    : "bg-emerald-50 text-emerald-700 border border-emerald-200"
                }`}
              >
                {item.transaction_type}
              </span>
            </td>
            <td className={`py-2.5 px-3 text-right font-bold ${isDecrease ? "text-red-600" : "text-emerald-600"}`}>
              {isDecrease ? `-${item.quantity}` : `+${item.quantity}`}
            </td>
            <td className="py-2.5 px-3 text-right text-gray-500 font-mono">
              {item.previous_quantity}
            </td>
            <td className="py-2.5 px-3 text-right font-bold font-mono text-gray-900">
              {item.new_quantity}
            </td>
            
            {/* Customer Details Column */}
            <td className="py-2.5 px-3">
              {item.customer_name ? (
                <div>
                  <div className="font-semibold text-gray-900">{item.customer_name}</div>
                  <div className="text-[11px] text-gray-500">{item.customer_email || "-"}</div>
                  {item.customer_contact_number && (
                    <div className="text-[10px] text-gray-400 font-mono">
                      {item.customer_contact_number}
                    </div>
                  )}
                </div>
              ) : (
                <span className="text-gray-400">Direct / Manual</span>
              )}
            </td>

            {/* Customer Location Column */}
            <td className="py-2.5 px-3 text-gray-600">
              {location || "-"}
            </td>

            {/* Inquiry Reference Column */}
            <td className="py-2.5 px-3 text-gray-600 font-mono text-[11px]">
              {item.inquiry_id ? (
                <span className="text-black font-medium">
                  {item.inquiry_id}
                </span>
              ) : (
                <span className="text-gray-400">Direct / Manual</span>
              )}
            </td>
            
            {/* <td className="py-2.5 px-3 text-gray-600 italic">
              {item.note || "-"}
            </td> */}
          </tr>
        );
      })
    ) : (
      <tr>
        <td colSpan="8" className="py-8 text-center text-gray-500">
          No stock history records found for this product.
        </td>
      </tr>
    )}
  </tbody>
</table>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="mt-4 flex justify-end border-t pt-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md bg-gray-600 px-4 py-1.5 text-xs font-semibold text-white transition hover:bg-gray-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}